import Toast from 'react-bootstrap/Toast';
import { useState } from 'react';
import ToastContainer from 'react-bootstrap/ToastContainer';
function Disclaimer() {
    const [show, setShow] = useState(true);
    const toggleShow = () => setShow(!show);
    return (
        <ToastContainer className="p-3" position='bottom-end'>
        <Toast show={show} onClose={toggleShow} delay={5000} autohide bg='dark'>
            <Toast.Header>
                <img
                    src="holder.js/20x20?text=%20"
                    className="rounded me-2"
                    alt=""
                />
                <strong className="me-auto">Disclaimer</strong>
            </Toast.Header>
            <Toast.Body className='text-white'>😇This page is intended to be educational and fun. This may help increase awareness of particular behaviors that previously went unrecognized.
                They are not by themselves tools for diagnosing any type of health or psychological distress. This page is periodically updated and owned by Tarock, Inc.</Toast.Body>
        </Toast>
        </ToastContainer>
    );
}

export default Disclaimer;